import classNames from 'classnames';
import { TinySpinner } from 'components/shared/TinySpinner/TinySpinner';
import { useGridExcelExport } from 'routes/secondary-market-batch/grid/hooks/use-grid-excel-export';

type Props = { className?: string };

export function ExportButton({ className }: Props) {
  const { onExport, isExporting } = useGridExcelExport();
  return (
    <button
      className={classNames('btn btn-flat-secondary btn-xl btn-icon border-start border-opacity-40', className)}
      title="Export CSV"
      onClick={onExport}
    >
      {isExporting ? <TinySpinner /> : <i className="icon icon-sm">save_alt</i>}
    </button>
  );
}
